import React from 'react';
import Suite from './assets/chambre1.jpg';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './nosChambres.css';
const roomsData = [
  {
    id: 'chambre',
    title: 'Chambres',
    description: 'Découvrez nos suites communicantes et quadruples, idéales pour les familles ou groupes, alliant confort, espace et intimité.',
    image: Suite,
    direction: -100,
    ligneClass: 'ligneHorizontaleC',
    contentClass: 'ContenuC'
  }
];

const NosChambre = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate('/AobergeC'); // redirection vers la page Aoberge
  };

  return (
    <div className="main-section-room" id='room'>
      <h1>Nos Chambres</h1>
      <div>
        {roomsData.map((room) => (
          <motion.div
            key={room.id}
            initial={{ opacity: 0, x: room.direction }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.3 }}
            className="container-room"
          >
            <div className="block-room">
              <div className={room.contentClass}>
                <img src={room.image} alt={`Photo de ${room.title}`} loading="lazy" />
                <div className="descriptionC">
                  <h2>{room.title}</h2>
                  <p>{room.description}</p>
                  <button className="buttonC" onClick={handleExploreClick}>
                    Explore More
                  </button>
                </div>
              </div>
            </div>
            <div className={room.ligneClass}></div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default NosChambre;
